export default __webpack_public_path__ + "static/media/new-feature-bg.d0ef9756.svg";